import React, { useContext, useState } from "react";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { Presentation } from "../types/presentation";
import EventContext from "../contexts/event";
import UserContext from "../contexts/user";

const TopBar = ({
  presentation,
  setShowForumSidebar,
  forumIsOpen = false,
  forum = false,
  hasVideo,
  tab = 0
}: {
  presentation: Presentation;
  setShowForumSidebar?: (arg0: any) => void;
  forum?: boolean;
  forumIsOpen?: boolean;
  hasVideo?: boolean;
  tab?: number;
}) => {
  const eventContext = useContext(EventContext);
  const userContext = useContext(UserContext);
  const history = useHistory();
  const intl = useIntl();
  const [top, setTop] = useState(false);
  const [selectTab, setSelectTab] = useState(tab);

  //   const [watch , setWatch] = useState(false) ;
  // @ts-ignore
  return (
    <div className="topbar-container">
      {/* <div className="topbar-radius"> */}


      {/* quiz result tab */}
      {eventContext.presentationsWithResults.indexOf(presentation._id) > -1 && (
        <Button
          className={` topbar-hover-dimension topbar-button ${eventContext.forum ? "" : "deactivate"
            } ${selectTab === 0 ? "active-focus" : "active"
            }
        `}
          // disabled={!eventContext.forum}
          onClick={() => {
            setSelectTab(0);
            userContext.user
              ? history.push(
                `/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`
              )
              : (() => {
                const currentPath = window.location.pathname;
                window.location.href = `${currentPath}?tab=connexion`; // Diljith krishna added this to navigate the login page with this tab=connexion parameter , 29/01/2026
              })()

          }}
        >
          <img alt="forum" src="/icons/podium-ico.svg" />
          <span>{intl.formatMessage({ id: "quiz.results" })}</span>
        </Button>)}

      {/* quiz  tab */}
      {eventContext.quiz && (
        <Button
          className={` topbar-hover-dimension topbar-button ${eventContext.forum ? "" : "deactivate"
            } 
        ${selectTab === 1 ? "active-focus" : "active"
            }
        `}
          // disabled={!eventContext.forum}
          onClick={() => {
            setSelectTab(1);
            userContext.user
              ? history.push(
                `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
              )
              : (() => {
                const currentPath = window.location.pathname;
                window.location.href = `${currentPath}?tab=connexion`;  // Diljith krishna added this to navigate the login page with this tab=connexion parameter , 29/01/2026
              })()
          }}
        >
          <img alt="forum" src="/icons/quiz-ico.svg" />
          <span>Quiz</span>
        </Button>)}

      {/* manage quiz   tab */}
      {/* eslint-disable-next-line no-mixed-operators */}
      {(eventContext.quiz && userContext.user?.is_moderator === true) || (userContext.user?.speaker_id === presentation.speaker_id) && (
        <Button
          className={` topbar-hover-dimension topbar-button ${eventContext.forum ? "" : "deactivate"
            } 
        ${selectTab === 4 ? "active-focus" : "active"
            }
        `}
          // disabled={!eventContext.forum}
          onClick={() => {
            setSelectTab(4);
            userContext.user
              ? history.push(
                `/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`
              )
              : (() => {
                const currentPath = window.location.pathname;
                window.location.href = `${currentPath}?tab=connexion`; // Diljith krishna added this to navigate the login page with this tab=connexion parameter , 29/01/2026
              })()
          }}
        >
          <img alt="forum" src="/icons/edit_icon.svg" height={24} width={20} />
          <span>  MANAGE QUIZ</span>
        </Button>)}



      {/*forum tab*/}
      {eventContext.forum && (<Button
        className={` topbar-hover-dimension topbar-button ${eventContext.forum ? "" : "deactivate"
          } 
        ${selectTab === 2 ? "active-focus" : "active"
          }
        `}
        // disabled={!eventContext.forum}
        onClick={() => {
          //   if (Forum == false) {
          //       setWatch(false)
          //     setForum(true);
          setSelectTab(2);
          if (forum) {
            setShowForumSidebar && setShowForumSidebar((s: any) => {

              if (s) {
                setSelectTab(3);
              }

              return !s
            });
          } else {
            history.push(
              `/${eventContext.slug}/${presentation._id}/forum${document.location.search}`
            );
          }
          //   }
          //   if (Forum == true) {
          //     setWatch(false)
          //   setForum(true);
          //   if (forum ) {
          //     setShowForumSidebar && setShowForumSidebar((s: any) => !s);
          //   } else {
          //     history.push(
          //       `/${eventContext.slug}/${presentation._id}/forum${document.location.search}`
          //     );
          //   }
          // }
        }}
      >
        <img alt="forum" src="/icons/forum.svg" />
        <span>{intl.formatMessage({ id: "top.bar.forum" })}</span>
      </Button>)}


      <Button
        className={` topbar-hover-dimension topbar-button ${eventContext.forum ? "" : "deactivate"
          } 
        ${selectTab === 3 ? "active-focus" : "active"
          }
        `}
        // disabled={
        //   !presentation.publicVideo &&
        //   !presentation.webcam &&
        //   !presentation.video
        // }
        onClick={() => {
          //   if (watch == false) {
          //     setForum(false);
          //     setWatch(true)
          setSelectTab(3);
          setTop((s) => !s)
          setShowForumSidebar && setShowForumSidebar(false)
          history.push(
            `/${eventContext.slug}/${presentation._id}${document.location.search}`
          );
          //   }
          //   if (watch == true) {
          //     setForum(false);
          //     setWatch(true)
          //     history.push(
          //       `/${eventContext.slug}/${presentation._id}${document.location.search}`
          //     );
          //   }
        }}
      >
        <img src="/icons/video.svg" alt="video" />
        <span>
          <FormattedMessage id="button.watch-video" />
        </span>
      </Button>
      {/* {eventContext.presentationsWithQuestions.indexOf(presentation._id) >
        -1 && (
        <Button
          disabled={!eventContext.quiz}
          color="primary"
          className="quiz-btn"
          onClick={() => {
            userContext.user
              ? history.push(
                  `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                )
              : (() => {
  const currentPath = window.location.pathname;
  window.location.href = `${currentPath}?tab=connexion`; // Diljith krishna added this to navigate the login page with this tab=connexion parameter , 29/01/2026
})()
          }}
        >
          Quiz
          <img src="/icons/quiz-ico.svg" alt="quiz" />
        </Button>
      )} */}
      {/* {eventContext.presentationsWithResults.indexOf(presentation._id) > -1 && (
        <Button
          color="primary"
          className="quiz-res-btn"
          onClick={() => {
            userContext.user
              ? history.push(
                  `/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`
                )
              : (() => {
  const currentPath = window.location.pathname; 
  window.location.href = `${currentPath}?tab=connexion`; // Diljith krishna added this to navigate the login page with this tab=connexion parameter , 29/01/2026
})()
          }}
        >
          {intl.formatMessage({ id: "quiz.results" })}
        </Button>
      )} */}
      {/* </div> */}
    </div>
  );
};

export default TopBar;
